import { Testimonial } from '@/types'
import arabicaImage from '@/assets/img/testimonials/arabica.webp'
import zooImage from '@/assets/img/testimonials/zoo.webp'
import aquaImage from '@/assets/img/testimonials/aqua.webp'
import serhiiImage from '@/assets/img/testimonials/serhii.webp'
import issaImage from '@/assets/img/testimonials/issa.webp'
import kobaImage from '@/assets/img/testimonials/koba.webp'
import dimaImage from '@/assets/img/testimonials/dima.webp'
import nataliiaImage from '@/assets/img/testimonials/nataliia.webp'
import antonImage from '@/assets/img/testimonials/anton.webp'

export const testimonials: Testimonial[] = [
    {
        img: aquaImage,
        name: 'Evgeniy',
        companyName: 'Aqua-M',
        content: `
            <p>
                We would like to thank Olexiy for the offer to make an app for
                our business. This allowed us to update and send information to
                our customers more quickly. Orders from customers began to arrive
                much more often, all of them immediately noted the convenience of
                using the app.
            </p>
            <p>
                In general, the application allowed us to increase sales volumes
                and effectively use the working time of the sales department. We
                were satisfied with the result, we can recommend Olexiy 👍
            </p>
        `,
    },
    {
        img: zooImage,
        name: 'Alexander',
        companyName: 'Zoo Zoo Zoo',
        content: `
            <p>
                I was pleasantly surprised by the timing. Instead of the agreed two
                months, it took only 5 weeks to develop, the application with a tie
                to the site was ready and working. Thanks for the speed and quality.
            </p>
        `,
    },
    {
        img: arabicaImage,
        name: 'Sam',
        companyName: 'Arabica',
        content: `
            <p>
                Dear Alex, you're a good man and a good developer. We do really like
                you and appreciate you and your work. Thanks for your patience and
                good work 🤝 We'll miss your music in presentation videos🕺🏼💃🏻
            </p>
        `,
    },
    {
        img: serhiiImage,
        name: 'Serhii Cho',
        companyName: 'IT Specialist',
        content: `
            <p>
                I've helped Olexiy to get started with Android development with
                Java back in 2020 when he was transitioning from a different
                field into software development. It's an honor for me to be the
                first who was not only helping him to learn Java, but also being
                the first person he worked with.
            </p>
            <p>
                Olexiy is an eager learner and a disciplined programmer, always
                focused on delivering quality work. I'm amazed by his attention
                to details and his refactoring nature. I highly recommend 👍
                Olexiy as a software developer for any organization or project
                looking for someone who is dedicated, reliable, and has a passion
                for not just coding but for clean and maintainable code.
            </p>
            <p>
                We worked together on multiple, projects where I was providing
                the server-side APIs and WEB applications, while Olexiy was
                responsible for the Android app development and project
                management, as he dealt with the client directly.
            </p>
            <p>
                I will continue to work with Olexiy in the future, and make sure
                I always have his back. If you are looking for a skilled and
                reliable software developer, look no further than Olexiy. I am
                proud to recommend Olexiy as a software developer, who possesses
                not only technical skills but also project management and
                communication skills.
            </p>
        `,
        short: `
            <p>
                I've helped Olexiy to get started with Android development with Java
                back in 2020 when he was transitioning from a different field into
                software development. It's an honor for me to be the first who was
                not only helping him to learn Java, but also being the first person
                he worked with.
            </p>
        `,
    },
    {
        img: issaImage,
        name: 'Issa Aldzhamal',
        companyName: 'Flutter developer',
        content: `
            <p>Nice person and high skilled specialist in Android development.</p>
        `,
    },
    {
        img: kobaImage,
        name: 'Artem Koba',
        companyName: 'Back-end .Net developer',
        content: `
            <p>
                I am writing to highly recommend my colleague Alexey Chernenkiy
                for any Kotlin front-end development positions. I have had the
                pleasure of working alongside Alexey for the past 1.5 year, and I
                have consistently been impressed with his technical skills, work
                ethic, and professionalism.
            </p>
            <p>
                Alexey is a highly skilled Kotlin front-end developer with a deep
                understanding of front-end technologies. He is a quick learner,
                and he always stays up-to-date with the latest developments in
                his field. He is also a great team player who is always willing
                to collaborate and share his expertise with his colleagues.
            </p>
            <p>
                In addition to his technical skills, Alexey has excellent
                communication and problem-solving skills. He is always willing to
                take on new challenges and tackle difficult problems, and he
                approaches each task with a positive attitude and a strong work
                ethic. He is a true asset to any team and is highly respected by
                his colleagues.
            </p>
            <p>
                I highly recommend Alexey for any Kotlin front-end development
                positions. He is an outstanding developer who would be a valuable
                asset to any team.
            </p>
        `,
        short: `
            <p>
                I am writing to highly recommend my colleague Alexey Chernenkiy for
                any Kotlin front-end development positions. I have had the pleasure
                of working alongside Alexey for the past 1.5 year, and I have
                consistently been impressed with his technical skills, work ethic,
                and professionalism.
            </p>
        `,
    },
    {
        img: dimaImage,
        name: 'Dmitriy Mironiuk',
        companyName: 'CEO & Founder of Syject',
        content: `
            <p>Dear Olexiy,</p>
            <p>
                I am writing to express my sincere gratitude for the outstanding
                work you did as an Android developer at our company. Your
                contributions were instrumental in the success of several
                projects, and we are grateful for your hard work and dedication.
            </p>
            <p>
                Your technical skills and attention to detail were exemplary, and
                your ability to find creative solutions to complex problems was
                truly impressive. You consistently demonstrated a high level of
                professionalism and efficiency, and your work always exceeded our
                expectations.
            </p>
            <p>
                Moreover, your positive attitude and team spirit made you a
                pleasure to work with. You were always willing to lend a hand to
                your colleagues and were an invaluable member of the team. Your
                ability to collaborate and communicate effectively ensured that
                our projects were delivered on time and to the highest standards.
            </p>
            <p>
                You have left a lasting impact on our organization, and we wish
                you all the best in your future endeavors.
            </p>
            <p>
                Once again, thank you for your hard work and dedication. You have
                been an asset to our company, and we will miss you.
            </p>
            <p>Sincerely,</p>
            <p>Dmitriy Myroniuk</p>
            <p>CEO & Founder of Syject.</p>
        `,
        short: `
            <p>
                I am writing to express my sincere gratitude for the outstanding work
                you did as an Android developer at our company. Your contributions
                were instrumental in the success of several projects, and we are
                grateful for your hard work and dedication.
            </p>
        `,
    },
    {
        img: nataliiaImage,
        name: 'Nataliia Kholodnykh',
        companyName: 'Talent acquisition specialist',
        content: `
            <p>Шановний Олексій,</p>
            <p>
                Я хотіла би висловити свою повну підтримку Вам у якості Android
                розробника. Під час Вашої роботи в нашій компанії Syject, Ви
                продемонстрували високий рівень знань та вмінь у сфері IT та
                успішно справлялися зі своїми обов'язками.
            </p>
            <p>
                Ви виявили себе як досвідчений та ефективний розробник, завжди
                працюючи на високому рівні і дотримуючись строків. Ваші навички
                програмування та розуміння андроїд-розробки дозволили нам
                забезпечувати наші продукти високоякісними та
                конкурентоспроможними на ринку.
            </p>
            <p>
                Крім того, Ваша здатність до співпраці та комунікації з іншими
                членами нашої команди була вельми цінною та визнаною. Ви завжди
                готові були допомогти іншим, коли це було потрібно, Ваші
                радісність та енергія завжди були приємними для всіх.
            </p>
            <p>
                Тому, я би хотіла рекомендувати Вас як талановитого та
                досвідченого андроїд-розробника, який забезпечить високий рівень
                роботи і буде цінним спеціалістом до будь-якої команди в сфері
                айті. Я бажаю Вам успіхів у майбутніх проектах та розвитку
                кар'єри.
            </p>
            <p>З повагою,</p>
            <p>HR компанії Syject</p>
            <p>Наталі Холодних</p>
        `,
        short: `
            <p>
                Я хотіла би висловити свою повну підтримку Вам у якості Android
                розробника. Під час Вашої роботи в нашій компанії Syject, Ви
                продемонстрували високий рівень знань та вмінь у сфері IT та успішно
                справлялися зі своїми обов'язками.
            </p>
        `,
    },
    {
        img: antonImage,
        name: 'Anton Patenko',
        companyName: 'iOS Developer',
        content: `
            <p>
                We have been working with Alexey since 2021 in different
                companies and on numerous projects. Since the beginning of my
                journey in iOS development, Alexey has been very helpful in
                helping me adapt to the team and quickly understand the project.
            </p>
            <p>
                He is a very talented Android developer and a great partner in
                projects. Alexey is very diligent and capable of always figuring
                out any difficult moments in development. He has a well-developed
                critical thinking which helps bring to life any customer ideas.
                During our collaboration, we worked on many different projects
                and created a lot of features.
            </p>
            <p>
                I am very grateful to Alexey for being able to help and teach his
                skills to any developer at any time. I am proud to have had the
                opportunity to work with Alexey in the same team for such a long
                period of time!
            </p>
            <p>Highly recommend!</p>
        `,
        short: `
            <p>
                We have been working with Alexey since 2021 in different companies
                and on numerous projects. Since the beginning of my journey in iOS
                development, Alexey has been very helpful in helping me adapt to the
                team and quickly understand the project.
            </p>
        `,
    },
]
